import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { auth } from "./firebase";

// ── Username → Firebase email mapping ────────────────────────────────────────
// The UI accepts simple usernames; we map them to Firebase email addresses.
// These email accounts must exist in Firebase Console → Authentication → Users.
const USERNAME_TO_EMAIL = {
  admin:     "admin@atfsecure.com",
  recruiter: "recruiter@atfsecure.com",
};

/**
 * Sign in with a short username + password.
 * Resolves with { username } on success; throws on failure.
 * @param {string} username
 * @param {string} password
 */
export async function login(username, password) {
  const email = USERNAME_TO_EMAIL[username.toLowerCase()];
  if (!email) throw new Error("Invalid credentials");

  await signInWithEmailAndPassword(auth, email, password);
  // Persist display name so AdminDashboard can show it
  localStorage.setItem("atf_admin_user", username);
  return { username };
}

/**
 * Sign out the current admin and clear local state.
 */
export async function logout() {
  await signOut(auth);
  localStorage.removeItem("atf_admin_user");
}

/**
 * Subscribe to auth state changes.
 * Returns the unsubscribe function.
 * @param {(user: import("firebase/auth").User | null) => void} callback
 */
export function onAuthChange(callback) {
  return onAuthStateChanged(auth, callback);
}

/**
 * Returns the currently signed-in Firebase user (or null).
 */
export function getCurrentUser() {
  return auth.currentUser;
}
